module.exports = __webpack_public_path__ + "static/font-9917c2deeb481528d9090c2035b642e2.woff";